var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-results-details" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-4" },
            [
              _c(
                "router-link",
                {
                  staticClass: "btn btn-sm btn btn-primary",
                  attrs: { to: { name: "intern.create" } },
                },
                [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Add Intern")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "dashboard-block" },
        [
          _vm.fetchingInterns
            ? _c("pickstar-loading", { staticClass: "m-t-lg" })
            : _vm.haveNoInterns
            ? _c("no-results", [
                _vm._v("\n        There are no interns.\n      "),
              ])
            : _c(
                "ul",
                { staticClass: "item-detail item-detail-profile" },
                _vm._l(_vm.interns, function (intern) {
                  return _c("system-intern-management-list-item", {
                    key: intern.id,
                    attrs: { intern: intern },
                  })
                }),
                1
              ),
          _vm._v(" "),
          _c(
            "lazy-loading",
            {
              ref: "lazyLoading",
              staticClass: "text-center",
              attrs: {
                loading: _vm.loading,
                "reached-bottom": _vm.handleGetNextInternsCallback,
              },
            },
            [
              _c("pickstar-loading", {
                attrs: { slot: "loading" },
                slot: "loading",
              }),
              _vm._v(" "),
              _c("span", { attrs: { slot: "finished" }, slot: "finished" }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("\n        Intern Management\n      ")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }